import { render, staticRenderFns } from "./AIImport.vue?vue&type=template&id=20e42c74"
import script from "./AIImport.vue?vue&type=script&lang=js"
export * from "./AIImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports